"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyListRequest = void 0;
var MyListRequest = /** @class */ (function () {
    function MyListRequest() {
    }
    return MyListRequest;
}());
exports.MyListRequest = MyListRequest;
;
//# sourceMappingURL=myList.request.js.map